import { createReducer } from '../../helpers/reducers';
import { types } from '../../actions/app';

const initialState = null;

const handleRegisterSuccess = (state, action) => JSON.parse(action.payload.data.data).UserId;
const handleSetUserId = (state, action) => action.payload.userId;

const handlers = {
  [types.APP_SET_USER_ID]: handleSetUserId,
  [types.APP_REGISTER_SUCCESS]: handleRegisterSuccess,
};

const userId = createReducer(initialState, handlers);

export default userId;

export const getUserId = state => state.app.userId;



// WEBPACK FOOTER //
// ./src/reducers/app/userId.js